import type { TOC } from '@ember/component/template-only';
import { eq } from 'ember-truth-helpers';

interface PrismMetricBlockSignature {
  Args: {
    align?: 'center' | 'left';
    allowLabelTextWrapping?: boolean;
    compact?: boolean;
  };
  Blocks: {
    label: [];
    value: [];
  };
  Element: HTMLDivElement;
}

/**
 * @deprecated Use Prism foundation building blocks to build the layout yourself.
 */
const PrismMetricBlock: TOC<PrismMetricBlockSignature> = <template>
  <div
    class="prism-metric-block
      {{if (eq @align 'left') 'prism-metric-block--left-aligned'}}
      {{if @compact 'prism-metric-block--compact'}}"
    ...attributes
  >
    <div
      class="prism-metric-block__value text-400--regular"
      data-test-id="prism-metric-block-value"
    >
      {{yield to="value"}}
    </div>
    <div
      class="prism-metric-block__label text-200--regular
        {{if
          @allowLabelTextWrapping
          'prism-metric-block__label--text-wrapping'
          'truncate'
        }}"
      data-test-id="prism-metric-block-label"
    >
      {{yield to="label"}}
    </div>
  </div>
</template>;

export default PrismMetricBlock;
